/*
|--------------------------------------------------------------------------
| Rootslane Delivery Engine
|--------------------------------------------------------------------------
| Calculates delivery charges based on configured distance slabs.
|--------------------------------------------------------------------------
*/

window.RootslaneDelivery = {

    /**
     * Get delivery rule for a given distance
     */
    getRule(distanceKm) {

        const rules = RootslaneConfig.delivery.rules;

        return rules.find(rule =>
            distanceKm >= rule.minKm &&
            distanceKm < rule.maxKm
        ) || null;

    },

    /**
     * Calculate driving distance between warehouse and customer
     */
    async getDistance(customerLat, customerLng) {

        const warehouse = RootslaneConfig.warehouse;

        const service = new google.maps.DistanceMatrixService();

        return new Promise((resolve) => {

            service.getDistanceMatrix({

                origins: [
                    new google.maps.LatLng(
                        warehouse.lat,
                        warehouse.lng
                    )
                ],

                destinations: [
                    new google.maps.LatLng(
                        customerLat,
                        customerLng
                    )
                ],

                travelMode: google.maps.TravelMode.DRIVING,

                unitSystem: google.maps.UnitSystem.METRIC

            }, (response, status) => {

                /* Google API failed */

                if (status !== "OK") {

                    resolve({

                        distanceKm: null,

                        distanceText: "",

                        durationText: "",

                        charge: RootslaneConfig.delivery.defaultCharge,

                        eta: RootslaneConfig.delivery.defaultEta,

                        variantId:
                            RootslaneConfig.delivery.deliveryVariants[
                                RootslaneConfig.delivery.defaultCharge
                            ],

                        fallback: true,

                        rule: null

                    });

                    return;

                }

                const result =
                    response.rows[0].elements[0];

                /* Route not found */

                if (result.status !== "OK") {

                    resolve({

                        distanceKm: null,

                        distanceText: "",

                        durationText: "",

                        charge: RootslaneConfig.delivery.defaultCharge,

                        eta: RootslaneConfig.delivery.defaultEta,

                        variantId:
                            RootslaneConfig.delivery.deliveryVariants[
                                RootslaneConfig.delivery.defaultCharge
                            ],

                        fallback: true,

                        rule: null

                    });

                    return;

                }

                const distanceKm =
                    result.distance.value / 1000;

                const rule =
                    this.getRule(distanceKm);

                resolve({

                    distanceKm,

                    distanceText: result.distance.text,

                    durationText: result.duration.text,

                    charge: rule
                        ? rule.charge
                        : RootslaneConfig.delivery.defaultCharge,

                    eta: rule
                        ? rule.eta
                        : RootslaneConfig.delivery.defaultEta,

                    variantId:
                        RootslaneConfig.delivery.deliveryVariants[
                            rule
                                ? rule.charge
                                : RootslaneConfig.delivery.defaultCharge
                        ],

                    fallback: false,

                    rule

                });

            });

        });

    }

};